/* template */
<template><div class="mpx-root-view"><ts-collapse :expand="(hasSeatSelected && !hasRightsChoosed)" :refreshTrigger="(refreshTrigger)" :fadeDuration="(0.5)" :externClass='["seat-rights-select-group"].join(" ")'><seat-rights-select-card :ref='("card"+(item?.type))' v-for="(item, index) in (rightsInfo)" :serviceInfo="(item)" :seatInfo="(selectSeatInfo)" @click="seatInfoClickReport" @openRightsDescDrawer="openRightsDescDrawer" @showBaichuanPrivacyDrawer="showBaichuanPrivacyDrawer"/></ts-collapse><Privacy :list="(baichuanTrainPrivacy)" @privacyVerify="privacyVerify" v-if="(showPrivacy)"/></div></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m0ac0036d"}'>
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m0ac0036d"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex0ac0036d%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex0ac0036d%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m0ac0036d"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index0ac0036d/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'Privacy':getComponent(require("../../../train-detail/components/privacy/index.mpx?isComponent&outputPath=components%2Findex6f368ef8%2Findex")),'seat-rights-select-card':getComponent(require("./seat-rights-select-card.mpx?isComponent&outputPath=components%2Fseat-rights-select-card096da42e%2Findex")),'ts-collapse':getComponent(require("../../../../../node_modules/@didi/spring-ui/ts-collapse/index.mpx?isComponent&outputPath=components%2Findex3239cc50%2Findex"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
